"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFieldToJSON = exports.SortFieldFromJSONTyped = exports.SortFieldFromJSON = exports.SortField = void 0;
/**
 *
 * @export
 */
exports.SortField = {
    CreatedAt: 'CREATED_AT',
    Name: 'NAME'
};
function SortFieldFromJSON(json) {
    return SortFieldFromJSONTyped(json, false);
}
exports.SortFieldFromJSON = SortFieldFromJSON;
function SortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SortFieldFromJSONTyped = SortFieldFromJSONTyped;
function SortFieldToJSON(value) {
    return value;
}
exports.SortFieldToJSON = SortFieldToJSON;
